import { ResponsesTypes } from '@/entities/checklist';
import { LegacyInspection, LegacyItem } from '@/ui/components/inspectionReport/legacyTypes';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
import { h } from 'vue';
import {
  Annotation,
  Checkbox,
  Instruction,
  ConductedAt,
  ConductedBy,
  Datetime,
  Dropdown,
  EntityItem,
  EntityItemAutomatic,
  List,
  NumberQuestion,
  Photo,
  QrCode,
  Signature,
  TextQuestion,
  Geolocation,
  File,
  UnknownQuestion,
} from '@/ui/components/inspectionReport/questions';

export default class QuestionFactory {
  resource: LegacyInspection | null;

  constructor() {
    this.resource = useInspectionReport().resource.value;
  }

  getQuestion(item: LegacyItem, questionProps = { withIssues: false }) {
    return h(this.getQuestionType(item), {
      props: {
        ...questionProps,
        item,
      },
    });
  }

  private getQuestionType(item: LegacyItem) {
    switch (item.response_type) {
      case ResponsesTypes.list: {
        const responseSets = this.resource?.form?.params?.response_sets ?? [];
        const responseSet = responseSets.find(
          ({ uuid }) => uuid === item.params.response_set,
        );
        switch (responseSet?.type) {
          case ResponsesTypes.dropdown:
            return Dropdown;
          case ResponsesTypes.list:
          default:
            return List;
        }
      }

      case ResponsesTypes.text:
        return TextQuestion;
      case ResponsesTypes.number:
        return NumberQuestion;
      case ResponsesTypes.checkbox:
        return Checkbox;
      case ResponsesTypes.datetime:
        return Datetime;
      case ResponsesTypes.photo:
        return Photo;
      case ResponsesTypes.annotation:
        return Annotation;
      case ResponsesTypes.signature:
        return Signature;
      case ResponsesTypes.instruction:
        return Instruction;
      case ResponsesTypes.userAutomatic:
        return ConductedBy;
      case ResponsesTypes.dateTimeAutomatic:
        return ConductedAt;
      case ResponsesTypes.entityItemAutomatic:
        return EntityItemAutomatic;
      case ResponsesTypes.qrCode:
        return QrCode;
      case ResponsesTypes.geoLocation:
        return Geolocation;
      case ResponsesTypes.entityItem:
        return EntityItem;
      case ResponsesTypes.file:
        return File;
      default:
        return UnknownQuestion;
    }
  }
}
